import { render, staticRenderFns } from "./EditDeliverable.vue?vue&type=template&id=9622298a"
import script from "./EditDeliverable.vue?vue&type=script&lang=js"
export * from "./EditDeliverable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports